import { Link } from "react-router-dom";
import { Instagram, Phone, Mail, MapPin } from "lucide-react";
import { CONTACT, LOGO_URL } from "@/data/content";

export default function Footer() {
  return (
    <footer
      className="mt-32"
      style={{ background: "var(--ooe-dark)", color: "var(--ooe-on-dark)" }}
      data-testid="site-footer"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-20 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-4">
            <img src={LOGO_URL} alt="Out of Eden" className="h-14 w-14 object-contain" />
            <div>
              <div className="font-serif-display text-3xl">Out of Eden</div>
              <div className="eyebrow" style={{ color: "rgba(249,248,246,0.6)" }}>Feel Good Food</div>
            </div>
          </div>
          <p className="mt-8 max-w-md text-[15px] leading-relaxed" style={{ color: "rgba(249,248,246,0.75)" }}>
            Catering, private chef &amp; meal prep services rooted in London, Ontario.
            Thoughtfully prepared, nutrient-rich cuisine crafted from the finest ingredients.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="eyebrow mb-5" style={{ color: "rgba(249,248,246,0.55)" }}>Explore</div>
          <ul className="space-y-3 text-[15px]">
            {[
              ["Home", "/"],
              ["About", "/about"],
              ["Services", "/services"],
              ["Menus", "/menus"],
              ["Gallery", "/gallery"],
              ["Contact", "/contact"],
            ].map(([l, h]) => (
              <li key={h}><Link to={h} className="hover:underline" data-testid={`footer-link-${l.toLowerCase()}`}>{l}</Link></li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="eyebrow mb-5" style={{ color: "rgba(249,248,246,0.55)" }}>Get in touch</div>
          <ul className="space-y-4 text-[15px]">
            <li className="flex items-center gap-3" data-testid="footer-email">
              <Mail size={16} />
              <a href={`mailto:${CONTACT.email}`} className="hover:underline">{CONTACT.email}</a>
            </li>
            <li className="flex items-center gap-3" data-testid="footer-phone">
              <Phone size={16} />
              <a href={`tel:${CONTACT.phone.replace(/-/g, "")}`} className="hover:underline">{CONTACT.phone}</a>
            </li>
            <li className="flex items-center gap-3" data-testid="footer-instagram">
              <Instagram size={16} />
              <a href={CONTACT.instagramUrl} target="_blank" rel="noreferrer" className="hover:underline">{CONTACT.instagram}</a>
            </li>
            <li className="flex items-center gap-3" data-testid="footer-location">
              <MapPin size={16} />
              <span>{CONTACT.location}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t" style={{ borderColor: "rgba(249,248,246,0.12)" }}>
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row justify-between items-start md:items-center gap-3 text-[12px]" style={{ color: "rgba(249,248,246,0.55)" }}>
          <div>© {new Date().getFullYear()} Out of Eden — {CONTACT.website}</div>
          <div className="eyebrow" style={{ color: "rgba(249,248,246,0.55)" }}>Crafted with intention</div>
        </div>
      </div>
    </footer>
  );
}
